import PropTypes from 'prop-types';
import React from 'react';

export const ICON_BY_NOTE_GROUP = {
  black_fruit: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="black_fruit-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>blackberries_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#2c3e80" />
      <circle cx="36" cy="36" r="35" fill="url(#black_fruit-a)" />
      <path
        d="M37.2455,34.5625a9.3346,9.3346,0,0,1,1.1013,2.9066"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5046,45.0654a9.2437,9.2437,0,0,0,1.8422-7.5963"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2455,34.5625a10.0753,10.0753,0,0,0-8.7311-4.9253,10.3688,10.3688,0,0,0-2.4718.308"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0426,29.9452A9.7091,9.7091,0,0,0,18.5,39.2739a9.831,9.831,0,0,0,10.0144,9.6367,10.122,10.122,0,0,0,7.99-3.8452"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="26.75 40.251 24.902 40.58 23.055 40.251 22.81 42.043 21.913 43.632 23.609 44.411 24.902 45.722 26.195 44.411 27.892 43.632 26.995 42.043 26.75 40.251"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5126,30.7343a10.3556,10.3556,0,0,1,2.7273.4344,9.5721,9.5721,0,0,1,6.5454,12.0855,10.0944,10.0944,0,0,1-12.559,6.2986,9.8965,9.8965,0,0,1-5.7217-4.4874"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2455,34.5625a10.1708,10.1708,0,0,1,8.2671-3.8282"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="45.552 42.933 43.899 42.653 43.695 44.256 42.908 45.682 44.429 46.363 45.596 47.525 46.739 46.343 48.247 45.635 47.433 44.223 47.199 42.624 45.552 42.933"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5126,30.7343a9.5742,9.5742,0,0,0-6.626-11.7871,10.0944,10.0944,0,0,0-12.559,6.2986,9.2444,9.2444,0,0,0-.285,4.6994"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="35.146 25.604 36.752 24.849 35.885 23.346 35.636 21.643 33.882 21.972 32.121 21.674 31.905 23.381 31.066 24.9 32.686 25.626 33.928 26.862 35.146 25.604"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  non_oak: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="non_oak-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>ageing_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#9e6e40" />
      <circle cx="36" cy="36" r="35" fill="url(#non_oak-a)" />
      <ellipse
        cx="20.8305"
        cy="41.9901"
        rx="5.8305"
        ry="5.8433"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="36"
        cy="41.9901"
        rx="5.8305"
        ry="5.8433"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="51.1695"
        cy="41.9901"
        rx="5.8305"
        ry="5.8433"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="28.4153"
        cy="28.0099"
        rx="5.8305"
        ry="5.8433"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="43.5847"
        cy="28.0099"
        rx="5.8305"
        ry="5.8433"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  red_fruit: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="red_fruit-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>redberries_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#c73a31" />
      <circle cx="36" cy="36" r="35" fill="url(#red_fruit-a)" />
      <path
        d="M42.4453,22.7183a5.1922,5.1922,0,0,0,4.5088.7055,5.18,5.18,0,0,0-6.7094-4.6932A5.1631,5.1631,0,0,0,42.4453,22.7183Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.5467,24.5526s-10.0771-1.684-16.7,6.6649"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5509,35.7626c-.3655-2.0165-1.29-3.6232-2.3336-3.9775-1.8337-.6223-2.35.11-3.2293-.188s-1.0019-1.2479-2.6818-1.818c-1.53-.5192-5.8362,2.1383-7.0875,5.8056a7.7893,7.7893,0,0,0,5.0252,9.9179,7.6443,7.6443,0,0,0,7.8084-1.5079"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5509,35.7626a3.51,3.51,0,0,1,2.1164-1.31c1.7744,0,2.1973.8595,3.126.8595s1.1809-.8595,3.1179-.8595,4.7763,3.7709,4.7763,7.7739A7.6691,7.6691,0,0,1,40.7933,50a7.7882,7.7882,0,0,1-7.741-6.0053"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5509,35.7626a10.09,10.09,0,0,0-2.7182,6.4626,7.6,7.6,0,0,0,.22,1.77"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.9959,24.5279a12.8551,12.8551,0,0,0-6.2026,10.7837"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dried_fruit: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="dried_fruit-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>driedfruit_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#b9655d" />
      <circle cx="36" cy="36" r="35" fill="url(#dried_fruit-a)" />
      <path
        d="M33.6611,28.519c-1.84-1.9716-3.3121-2.0641-3.9115-3.0676-1.0639-1.7811.1864-5.6389-2.1893-5.6389s-1.2961,3.2261-2.8027,5.8308c-.8263,1.4285-2.7543,2.0544-4.3277,3.8147a11.044,11.044,0,0,0-2.3444,2.5464l-.0061.0064h.0019a10.5159,10.5159,0,0,0-1.7688,5.8362c0,5.8576.7415,10.6308,10.5626,10.84.2237.0048.4521-.5411.6852-.5411.2886,0,.57.5446.8437.5373A12.1665,12.1665,0,0,0,33.32,47.71"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2,31.9165A10.7512,10.7512,0,0,0,30.6511,29.63"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3056,30.9024c-5.5656,5.0563-5.6325,11.0894-2.6611,13.3389"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.56,29.0826a49.4069,49.4069,0,0,0-1.4007,10.61C26.3035,44,27.56,45.1662,27.56,45.1662"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.9187,32.0108h.0019l-.0061-.0062a11.0591,11.0591,0,0,0-2.6069-2.7456c-1.8406-1.9716-4.0794-2.804-4.6788-3.8076-1.0638-1.7811.1865-5.6389-2.1892-5.6389s-1.2962,3.2261-2.8027,5.8308c-.8264,1.4285-2.7543,2.0544-4.3277,3.8147a11.04,11.04,0,0,0-2.3444,2.5465l-.0061.0063h.0018a10.5167,10.5167,0,0,0-1.7688,5.8362c0,5.8576.7415,10.6308,10.5627,10.84.2237.0047.452-.5411.6852-.5411.2885,0,.57.5446.8436.5373,9.6708-.2575,10.4043-5.0108,10.4043-10.8367A10.5159,10.5159,0,0,0,53.9187,32.0108Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.4492,37.8456c0,4.0348-.136,7.347-6.7977,7.6945-.3821.02-.7856-.3052-1.2119-.3052-.3433,0-.672.3287-.9866.3157-6.8839-.2842-7.0229-3.6252-7.0229-7.705a8.0148,8.0148,0,0,1,16.0191,0Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M40.4825,41.7886a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M40.4825,44.7484a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M43.7125,43.2685a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M45.8532,41.3124a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M46.4419,43.8453a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M48.9221,42.5286a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M51.2238,40.3087a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M48.9221,38.4148a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M45.8532,38.8289a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M42.7842,39.87a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M41.6837,38.0889a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M38.1808,39.5688a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M38.948,36.609a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M41.25,35.1291a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M42.017,32.9093a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M45.0859,33.6493a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M44.3187,35.8691a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M47.3876,36.609a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M51.2238,36.609a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M48.7882,35.1291a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M48.1549,32.9093a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
    </svg>
  ),
  spices: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="spices-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>spices_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#b19157" />
      <circle cx="36" cy="36" r="35" fill="url(#spices-a)" />
      <rect
        x="26.9846"
        y="50.7348"
        width="18.0308"
        height="3.6402"
        rx="0.91"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="36.0896"
        y1="36.3042"
        x2="45.5814"
        y2="27.4532"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="48.6527"
        y1="30.7888"
        x2="44.2468"
        y2="36.3622"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.7953,31.2682,45.14,26.2122a2.2157,2.2157,0,0,1,0-2.9417h0a1.8147,1.8147,0,0,1,2.7085,0l4.6553,5.056a2.2157,2.2157,0,0,1,0,2.9417h0A1.815,1.815,0,0,1,49.7953,31.2682Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6125,20.8754a7.9293,7.9293,0,0,0-.8106,6.4474,6.71,6.71,0,0,0,5.19-3.2505,7.929,7.929,0,0,0,.8106-6.4473A6.7093,6.7093,0,0,0,34.6125,20.8754Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="37.6638"
        y1="21.075"
        x2="32.1739"
        y2="29.9904"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2672,28.2845a8.85,8.85,0,0,0,6.6387,4.53A10.3952,10.3952,0,0,0,26.14,24.34a8.85,8.85,0,0,0-6.6386-4.53A10.3946,10.3946,0,0,0,20.2672,28.2845Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="22.1335"
        y1="24.442"
        x2="28.9548"
        y2="36.3622"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6093,36.3042v5.07c0,5.1482,3.8783,9.36,8.6185,9.36H42.7722c4.74,0,8.6185-4.2121,8.6185-9.36v-5.07Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  earth: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="earth-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>earthy_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#b59b6f" />
      <circle cx="36" cy="36" r="35" fill="url(#earth-a)" />
      <path
        d="M36,20.25c-10.1482,0-18.3749,5.4461-18.3749,12.1641a8.2814,8.2814,0,0,0,.4033,2.5377A137.5762,137.5762,0,0,0,36,36.086a137.5755,137.5755,0,0,0,17.9717-1.1342,8.2784,8.2784,0,0,0,.4034-2.5377C54.375,25.6961,46.1482,20.25,36,20.25Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5826,35.9425a16.2536,16.2536,0,0,1,.8474,5.2647c0,6.2419-.33,10.3989-7.375,10.5378-6.6225.1306-7.9152-2.2937-7.3749-10.5378a20.53,20.53,0,0,1,.8472-5.2645"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="26.4259"
        y1="35.7158"
        x2="26.1499"
        y2="32.5811"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="50.4532"
        y1="35.35"
        x2="50.8157"
        y2="32.2225"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="23.6085"
        y1="34.8704"
        x2="23.3326"
        y2="31.7357"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="44.4669"
        cy="29.2323"
        rx="1.3125"
        ry="1.1816"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="40.0278"
        cy="25.9083"
        rx="1.3125"
        ry="1.1816"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="27.563"
        cy="26.7537"
        rx="1.3125"
        ry="1.1816"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  citrus_fruit: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="citrus_fruit-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>citrus_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#ee803e" />
      <circle cx="36" cy="36" r="35" fill="url(#citrus_fruit-a)" />
      <path
        d="M49.1563,35.125a16.2686,16.2686,0,0,0-1.2478-6.4971c1.5377-3.6513,1.7607-6.6766.3027-8.2169s-4.3216-1.3047-7.7779.32a14.0834,14.0834,0,0,0-16.2889,3.2115A16.13,16.13,0,0,0,20.989,40.87c-1.8311,3.9859-2.19,7.3237-.6329,8.9685s4.7166,1.266,8.49-.6685A13.9872,13.9872,0,0,0,36.81,50.1778"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2166,50.875c8.2337,0,14.9084-7.0515,14.9084-15.75H26.3082C26.3082,43.8235,32.9829,50.875,41.2166,50.875Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.25,39.2344l.111,7.1066A6.4887,6.4887,0,0,0,47.5461,44.7Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.9622,38.7523l3.9871,3.3591a5.5568,5.5568,0,0,0,1.11-3.3771Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7875,39.2344l-.111,7.1066A6.4887,6.4887,0,0,1,35.4914,44.7Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.0753,38.7523l-3.9871,3.3591a5.5568,5.5568,0,0,1-1.11-3.3771Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M41.6075,31.413a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M33.4263,28.1719a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
      <path d="M30.3584,29.2523a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z" fill="#fff" />
    </svg>
  ),
  tropical_fruit: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="tropical_fruit-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>tropical_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#e99228" />
      <circle cx="36" cy="36" r="35" fill="url(#tropical_fruit-a)" />
      <path
        d="M42.3812,27.0442H29.6187A9.2869,9.2869,0,0,0,25.5,34.6409V45.7664c0,5.216,4.5756,9.4836,10.1681,9.4836h.6638c5.5925,0,10.1681-4.2676,10.1681-9.4836V34.6409A9.2869,9.2869,0,0,0,42.3812,27.0442Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6057,51.3949a2.6529,2.6529,0,0,0,2.7118-1.7806,2.6527,2.6527,0,0,0,2.7118,1.7806"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8865,51.3949a2.6529,2.6529,0,0,0,2.7118-1.7806A2.6527,2.6527,0,0,0,44.31,51.3949"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6057,42.8463a2.6529,2.6529,0,0,0,2.7118-1.7807,2.6528,2.6528,0,0,0,2.7118,1.7807"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8865,42.8463a2.6529,2.6529,0,0,0,2.7118-1.7807A2.6528,2.6528,0,0,0,44.31,42.8463"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.2461,47.4494a2.6529,2.6529,0,0,0,2.7118-1.7807A2.6528,2.6528,0,0,0,38.67,47.4494"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6057,34.2976a2.6529,2.6529,0,0,0,2.7118-1.7807,2.6528,2.6528,0,0,0,2.7118,1.7807"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8865,34.2976a2.6529,2.6529,0,0,0,2.7118-1.7807A2.6528,2.6528,0,0,0,44.31,34.2976"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.2461,38.9007A2.6529,2.6529,0,0,0,35.9579,37.12,2.6527,2.6527,0,0,0,38.67,38.9007"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.2461,30.352a2.6529,2.6529,0,0,0,2.7118-1.7806A2.6527,2.6527,0,0,0,38.67,30.352"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="33.977 19.304 35.958 13.25 37.945 19.309"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="31.4453"
        y1="27.0442"
        x2="34.8439"
        y2="27.0442"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="37.0827"
        y1="27.0441"
        x2="40.4812"
        y2="27.044"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="36.6706"
        y1="27.0441"
        x2="37.0827"
        y2="27.0441"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="36.6706"
        y1="27.0441"
        x2="34.8439"
        y2="27.0442"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5818,21.3013a14.762,14.762,0,0,0-4.769-.9773,7.5788,7.5788,0,0,1,3.8058,6.72h1.8267"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="34.8439"
        y1="27.0442"
        x2="34.8439"
        y2="27.0442"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.0827,27.0441h5.2252a7.5788,7.5788,0,0,1,3.8059-6.72,14.76,14.76,0,0,0-4.7691.9773"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="37.0827"
        y1="27.0441"
        x2="37.0827"
        y2="27.044"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5818,21.3013A10.5442,10.5442,0,0,0,27.64,16.4907a9.9039,9.9039,0,0,1,6.3379,2.8135"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.9774,19.3042a8.909,8.909,0,0,1,1.9859,3.2547"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6706,27.044a13.2646,13.2646,0,0,0-.7073-4.4851"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5818,21.3013a18.14,18.14,0,0,1,.8635,5.7429"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="36.671 27.044 36.671 27.044 34.844 27.044"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="36.6706"
        y1="27.0441"
        x2="36.6706"
        y2="27.044"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="31.4453"
        y1="27.0442"
        x2="34.8439"
        y2="27.0442"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3447,21.3013a18.135,18.135,0,0,0-.8635,5.7427"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.9446,19.3087a8.9084,8.9084,0,0,0-1.9813,3.25"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="36.6706"
        y1="27.044"
        x2="37.0827"
        y2="27.044"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3447,21.3013a10.5429,10.5429,0,0,1,2.9424-4.8107,9.9025,9.9025,0,0,0-6.3425,2.8181"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="40.4812"
        y1="27.044"
        x2="37.0827"
        y2="27.044"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tree_fruit: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="tree_fruit-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>treefruit_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#819632" />
      <circle cx="36" cy="36" r="35" fill="url(#tree_fruit-a)" />
      <path
        d="M34.7092,18.1557a5.3221,5.3221,0,0,0,4.3173-.6635,4.8285,4.8285,0,0,0-3.2125-2.737,5.3222,5.3222,0,0,0-4.3172.6634A4.8285,4.8285,0,0,0,34.7092,18.1557Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.39,17.0226s-5.9485,1.2245-5.9485,6.2479"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.6891,31.5052v-3.79c0-3.6355-3.2307-6.61-7.18-6.61h0c-3.9486,0-7.1794,2.9745-7.1794,6.61V31.891A10.7847,10.7847,0,0,0,32.713,52.4973,10.5515,10.5515,0,0,0,36,51.9728v-.0034a10.5473,10.5473,0,0,0,3.2867.5279,10.7834,10.7834,0,0,0,3.4023-20.9921Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.65,23.5506a6.8608,6.8608,0,0,0,2.1247.56,2.3533,2.3533,0,0,0,1.46-.56"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="34.861 53.937 36 51.969 36.902 53.785"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  oak: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="oak-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>oaky_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#8c5433" />
      <circle cx="36" cy="36" r="35" fill="url(#oak-a)" />
      <path
        d="M48.575,23.6524a28.3492,28.3492,0,0,0-1.5109-3.6384,1.6569,1.6569,0,0,0-1.4545-.95l-19.0255-.1263a1.6538,1.6538,0,0,0-1.4655.9309,28.3167,28.3167,0,0,0-1.5532,3.6183"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M49.7867,42.7442a40.2459,40.2459,0,0,0,.04-14.19"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M23.3478,47.4621A27.8684,27.8684,0,0,0,25.3064,52.04a1.6553,1.6553,0,0,0,1.4293.9011l18.3273.1216a1.6519,1.6519,0,0,0,1.44-.8821,27.8214,27.8214,0,0,0,2.0116-4.5513"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M22.2566,28.3711a40.2436,40.2436,0,0,0-.1244,14.19"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M42.2571,23.6107c-.1884-1.1437-.4038-2.2288-.6434-3.2453a1.6777,1.6777,0,0,0-1.5924-1.3387l-7.8489-.0521a1.6741,1.6741,0,0,0-1.6078,1.3175c-.2515,1.0133-.4795,2.0954-.6811,3.2366"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M42.8005,42.6978c.209-2.209.3281-4.5518.3421-6.9791.0146-2.511-.0842-4.9327-.28-7.2107"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M29.7054,47.5041c.24,1.4948.5255,2.8917.8509,4.1692A1.6732,1.6732,0,0,0,32.14,52.9767l7.5179.05a1.67,1.67,0,0,0,1.5991-1.2823c.34-1.2731.6421-2.6661.8993-4.1576"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M29.2215,28.4174c-.2226,2.2753-.35,4.6955-.3641,7.2065-.0141,2.4273.0777,4.7715.261,6.9831"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M48.5652,28.5458,23.5185,28.38a1.7284,1.7284,0,0,1-1.6179-2.0334l.2-1.369a1.6849,1.6849,0,0,1,1.6383-1.4893l24.6622.1637a1.6883,1.6883,0,0,1,1.6208,1.5109l.1844,1.3715A1.7251,1.7251,0,0,1,48.5652,28.5458Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M48.2621,47.6271,23.6,47.4635a1.6885,1.6885,0,0,1-1.6209-1.5109l-.1844-1.3716a1.7252,1.7252,0,0,1,1.6414-2.0118l25.0467.1662a1.7283,1.7283,0,0,1,1.6179,2.0334l-.2,1.3691A1.6848,1.6848,0,0,1,48.2621,47.6271Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
    </svg>
  ),
  floral: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="floral-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>floral_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#f86676" />
      <circle cx="36" cy="36" r="35" fill="url(#floral-a)" />
      <path
        d="M40.9378,36.3746A4.9378,4.9378,0,1,1,36,31.4368,4.9378,4.9378,0,0,1,40.9378,36.3746Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1983,32.3288S24.5749,17.472,36.0246,17.472c11.3362,0,2.8259,14.8568,2.8259,14.8568"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8646,32.2817s9.9163-14.0268,14.6843-3.6171c4.7207,10.3066-12.33,8.756-12.33,8.756"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1354,32.2817s-9.9163-14.0268-14.6843-3.6171c-4.7207,10.3066,12.3305,8.756,12.3305,8.756"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1828,41.4136s4.5821,16.5557,12.5927,8.3748c7.9311-8.1-8.6381-12.4134-8.6381-12.4134"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.7624,41.4136S30.18,57.9693,22.17,49.7884c-7.9311-8.1,8.6381-12.4134,8.6381-12.4134"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.8271,41.3094s1.3557,10.0329-1.0647,13.2186"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5476,39.8065s5.4948,6.2123,7.295,6.1608"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5776,34.525s8.7854-3.3711,8.7854-4.657"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36,31.4368s1.0387-7.1753,0-9.1813"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.4228,34.525s-7.16-4.1941-8.9092-3.7312"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1786,39.5013s-5.4472,5.643-6.013,6.7232"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  vegetal: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="vegetal-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>vegetal_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#9c9a2a" />
      <circle cx="36" cy="36" r="35" fill="url(#vegetal-a)" />
      <path
        d="M35.4275,16.4429a1.28,1.28,0,0,1,1.145,0c1.8208.92,1.4407,2.8031,1.4407,4.8068,0,1.3269,5.4651-2.5892,5.4651.8789,0,2.5054-4.5557,2.5054-4.5557,4.6914,0,2.1978,5.5654-1.97,5.5654.7533,0,4.2738-8.488,5.4846-8.488,5.4846s-8.488-1.2108-8.488-5.4846c0-2.7237,5.5654,1.4445,5.5654-.7533,0-2.186-4.5557-2.186-4.5557-4.6914,0-3.4681,5.4651.448,5.4651-.8789C33.9868,19.246,33.6067,17.3631,35.4275,16.4429Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M56.7478,38.3192a1.2787,1.2787,0,0,1,.1988,1.1275c-.59,1.953-2.51,1.9056-4.4836,2.2535-1.3068.23,3.4989,4.9325.0835,5.5348-2.4674.435-3.2585-4.0515-5.4113-3.6719-2.1644.3817,2.9069,5.1386.2246,5.6116-4.2089.7422-6.8752-7.4066-6.8752-7.4066s-.2815-8.5693,3.9274-9.3114c2.6823-.473-.4562,5.7316,1.7082,5.35,2.1528-.38,1.3617-4.866,3.8291-5.3011,3.4154-.6022.5078,5.46,1.8145,5.23C53.7371,37.387,55.5254,36.6858,56.7478,38.3192Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        d="M15.2522,38.3192a1.2787,1.2787,0,0,0-.1988,1.1275c.59,1.953,2.51,1.9056,4.4836,2.2535,1.3068.23-3.4989,4.9325-.0835,5.5348,2.4674.435,3.2585-4.0515,5.4113-3.6719,2.1644.3817-2.9069,5.1386-.2246,5.6116,4.2089.7422,6.8752-7.4066,6.8752-7.4066s.2815-8.5693-3.9274-9.3114c-2.6823-.473.4562,5.7316-1.7082,5.35-2.1528-.38-1.3617-4.866-3.8291-5.3011-3.4154-.6022-.5078,5.46-1.8145,5.23C18.2629,37.387,16.4746,36.6858,15.2522,38.3192Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <line
        x1="36"
        y1="28.8138"
        x2="36"
        y2="55.6924"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="36"
        y1="42.5125"
        x2="23.2597"
        y2="40.3438"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="48.7403"
        y1="40.3438"
        x2="36"
        y2="42.5125"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  microbio: (
    <svg width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <linearGradient
          id="microbio-a"
          x1="12.9988"
          y1="10.4546"
          x2="59.8168"
          y2="62.4513"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <title>yeasty_72pt</title>
      <circle cx="36" cy="36" r="36" fill="#c38349" />
      <circle cx="36" cy="36" r="35" fill="url(#microbio-a)" />
      <path
        d="M31.89,24.1525a20.3161,20.3161,0,0,1,8.22,0c4.4864.9266,11.4794,3.271,14.8505,9.1055,7.0348,12.1756-6.3867,10.9772-6.3867,10.9772H23.4262S10.0047,45.4336,17.04,33.258C20.4106,27.4235,27.4036,25.0791,31.89,24.1525Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9975,24.9374l-.4122,8.5951s.2812,2.32-2.5629,2.32-2.5629-2.32-2.5629-2.32l.4122-6.47"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.5629,23.8949l-.4122,9.6376s.2812,2.32-2.5629,2.32-2.5629-2.32-2.5629-2.32l.4122-9.6376"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.07,24.9374l-.4122,8.5951s-.2812,2.32,2.5628,2.32,2.5629-2.32,2.5629-2.32l.4122-6.47"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const TasteNote = ({ id }) => ICON_BY_NOTE_GROUP[id];

TasteNote.propTypes = {
  id: PropTypes.string.isRequired,
};

export default TasteNote;
